var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgComment2 = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.25006 3C3.91854 3 3.6006 3.1317 3.36618 3.36612C3.13176 3.60054 3.00006 3.91848 3.00006 4.25V19.2688L5.7371 16.7028C5.87611 16.5725 6.05951 16.4999 6.25006 16.4999H19.7676C20.0992 16.4999 20.4171 16.3683 20.6515 16.1338C20.8859 15.8994 21.0176 15.5815 21.0176 15.2499V4.25C21.0176 3.91848 20.8859 3.60054 20.6515 3.36612C20.4171 3.1317 20.0992 3 19.7676 3H4.25006ZM2.30552 2.30546C2.82124 1.78973 3.52071 1.5 4.25006 1.5H19.7676C20.497 1.5 21.1965 1.78973 21.7122 2.30546C22.2279 2.82118 22.5176 3.52066 22.5176 4.25V15.2499C22.5176 15.9793 22.2279 16.6788 21.7122 17.1945C21.1965 17.7102 20.497 17.9999 19.7676 17.9999H6.54665L2.76302 21.5471C2.54492 21.7516 2.22623 21.807 1.95192 21.6882C1.6776 21.5694 1.50006 21.299 1.50006 21V4.25C1.50006 3.52065 1.78979 2.82118 2.30552 2.30546Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComment2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/comment-2.f2c5bb470b79d904e2d3852ebe679051.svg";